/**
 * Output.js
 * Renders output box
 * Receives data from Lexer.js
 */

import { useContext } from "react";
import styled from "@emotion/styled";

import { Text, Box } from "@chakra-ui/react";

import { context } from "../context/GlobalState";

import { LexemesDrawer } from "./LexemesDrawer";
import { SymbolTableDrawer } from "./SymbolTableDrawer";

const Output = () => {
  const { state } = useContext(context);

  return (
    <Wrapper>
      <Header>
        <Text>OUTPUT</Text>
        <Box>
          <LexemesDrawer />
          <SymbolTableDrawer />
        </Box>
      </Header>
      {/* OutputBox -> styled div that renders the sourceCode */}
      <OutputBox>{state.outputMessage.toString()}</OutputBox>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  min-height: 100vh;
  background-color: #172b3a;
  color: #ffffff;
  padding: 2rem;
  max-height: 40vh;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  font-size: 2rem;
`;

const OutputBox = styled.div`
  word-wrap: anywhere;
  min-height: 100%;
  display: inline-block;
  line-height: 1.5;
  background-color: #172b3a;
  color: #ffffff;
  font-size: 16px;
  white-space: pre-line;
  height: auto;
  font-family: "Consolas", "Courier New", Courier, monospace;
`;

export default Output;
